<!-- 加上d=false进入测试模式 -->
<template>
    <div></div>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue';
import router from "@/router";
import store from '@/store';
import { LOCAL_STORE } from '@/config/constConfig';

watch(
    () => router.currentRoute.value.path,
    () => {
        check();
    }
);

onMounted(() => {
    check();
});

function check() {
    checkConvertVersion();
    checkIsDisbale();
    return ;
    let isUnCheck = getParameterByName("d");
    if (isUnCheck == "false") {
        return;
    }
    checkIsPhone();
    checkIsChinese();
};

/**检查是否手机打开*/
function checkIsPhone() {
    let isMobile = window.matchMedia("(pointer:coarse)").matches;
    if (!isMobile) {
        showDebugAlert();
    }
};

/**检查中文限制*/
function checkIsChinese() {
    let tempLanguage = navigator.language;
    if (tempLanguage.toLowerCase() == "zh-cn") {
        showDebugAlert();
    }
};

function checkConvertVersion() {
    let version = getParameterByName("v");
    if (version) {
        store.state.version = Number(version);
    }
}

/**检测玩家是否被禁用 */
function checkIsDisbale() {
    let isDsibale = localStorage.getItem(LOCAL_STORE.IS_DISBALE);
    if (isDsibale == "1") {
        store.state.isUserDisbale = true;
    }
}

/**显示403界面*/
function showDebugAlert() {
    window.location.replace("403.html");
    return;
};

/**获取路由参数 */
function getParameterByName(name: string, url: string = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};
</script>